export default "{\n    \"facilityLabel\": \"Instalación\",\n    \"suspended\": \"Suspendido\",\n    \"deactivated\": \"Desactivado\"\n}\n"